import { styled } from '@mui/material/styles'
import { Box } from '@mui/material'

export const GridWrapper = styled(Box)(({ theme }) => (`
    padding-top:10px;
    width:100%;
`))

export const TableWrapper = styled(Box)(({ theme }) => (`
    & th, & td { padding: 5px 10px; color: ${theme.components.GridList.styleOverrides.color} !important;}
    & tr:nth-of-type(even) {
        background-color: ${theme.components.GridList.styleOverrides.tdOddBackground};
    }
    & thead tr { border-bottom: 2px ${theme.components.GridList.styleOverrides.tdHoverBackground} solid;}
`))
